import { ClipboardCopyButton } from '@neo/blocks/clipboard-copy-button'
import { Button } from '@neo/index'
import { Separator } from '@neo/primitives/separator'
import { Download, Trash } from 'lucide-react'
import { getFormattedTime } from '../../run-info/analysis-v2/utils'
import type { EvalStreamEntry } from '../../types'
import { EVENT_LABELS } from './constants'

interface EvalActionsProps {
  events: EvalStreamEntry[]
  onDownload: () => void
  onClear: () => void
}

export const EvalActions = ({ events, onDownload, onClear }: EvalActionsProps) => {
  const hasEvents = events.length > 0

  const getCopyText = () => {
    return JSON.stringify(
      events.map((entry) => ({
        type: entry.type,
        label: EVENT_LABELS[entry.type] ?? entry.type,
        timestamp: getFormattedTime(new Date(entry.receivedAt).toISOString()),
        payload: entry.payload,
      })),
      null,
      2,
    )
  }

  return (
    <div className="flex items-center gap-1 rounded-md border border-st2 bg-background px-1 py-0.5">
      {hasEvents && (
        <ClipboardCopyButton
          textToCopy={getCopyText()}
          variant="ghost"
          size="icon"
          className="h-7 w-7"
          tooltipText="Copy simulation data"
          iconSize={12}
          data-testid="button-copy-eval-data"
        />
      )}
      <Button
        variant="ghost"
        size="icon"
        className="h-7 w-7"
        onClick={onDownload}
        disabled={!hasEvents}
        aria-label="Download simulation data as JSON"
        data-testid="button-download-eval-data"
      >
        <Download className="h-3 w-3" />
      </Button>
      {hasEvents && <Separator orientation="vertical" className="h-4" />}
      <Button
        variant="ghost"
        size="icon"
        className="h-7 w-7"
        onClick={onClear}
        disabled={!hasEvents}
        aria-label="Clear simulation log"
        data-testid="button-clear-eval-data"
      >
        <Trash className="h-3 w-3" />
      </Button>
    </div>
  )
}
